import classNames from 'classnames';

const ExclamationIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const { className = '', ...attributes } = props;
  const classes = classNames('exclamation-icon', className);

  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      className={classes}
      {...attributes}
    >
      <path
        d="M10.334 15.5C10.334 14.9477 10.7817 14.5 11.334 14.5C11.8863 14.5 12.3341 14.9477 12.3341 15.5C12.3341 16.0523 11.8864 16.5 11.3341 16.5C10.7818 16.5 10.334 16.0523 10.334 15.5Z"
        fill="#E5A116"
      />
      <path
        d="M10.584 6L10.584 12C10.584 12.4142 10.9198 12.75 11.334 12.75C11.7482 12.75 12.084 12.4142 12.084 12L12.084 6C12.084 5.58579 11.7482 5.25 11.334 5.25C10.9198 5.25 10.584 5.58579 10.584 6Z"
        fill="#E5A116"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.92497 1.34835C6.62824 0.645088 7.58206 0.25 8.57662 0.25H14.0913C15.0859 0.25 16.0397 0.645088 16.743 1.34835L20.9856 5.59099C21.6889 6.29425 22.084 7.24808 22.084 8.24264V13.7574C22.084 14.7519 21.6889 15.7057 20.9856 16.409L16.743 20.6516C16.0397 21.3549 15.0859 21.75 14.0913 21.75H8.57662C7.58206 21.75 6.62824 21.3549 5.92497 20.6516L1.68233 16.409C0.979073 15.7057 0.583984 14.7519 0.583984 13.7574V8.24264C0.583984 7.24808 0.979073 6.29425 1.68233 5.59099L5.92497 1.34835ZM8.57662 1.75C7.97989 1.75 7.40759 1.98705 6.98563 2.40901L2.74299 6.65165C2.32104 7.07361 2.08398 7.6459 2.08398 8.24264V13.7574C2.08398 14.3541 2.32104 14.9264 2.74299 15.3483L6.98563 19.591C7.40759 20.0129 7.97989 20.25 8.57662 20.25H14.0913C14.6881 20.25 15.2604 20.0129 15.6823 19.591L19.925 15.3483C20.3469 14.9264 20.584 14.3541 20.584 13.7574V8.24264C20.584 7.6459 20.3469 7.07361 19.925 6.65165L15.6823 2.40901C15.2604 1.98705 14.6881 1.75 14.0913 1.75H8.57662Z"
        fill="#E5A116"
      />
    </svg>
  );
};

export default ExclamationIcon;
